import { Component, OnDestroy, OnInit } from '@angular/core';
import { CartService } from 'app/main/services/cart.service';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'app/main/services/app.service';
import { ActivatedRoute } from '@angular/router';
import { BaseLanguageLoaderComponent } from '../base-language-loader.component';

@Component({
	selector: 'app-home',
	templateUrl: './thankyou.component.html',
	styleUrls: ['./thankyou.component.scss']
})
export class ThankYouComponent extends BaseLanguageLoaderComponent implements OnInit, OnDestroy {

	_status: any;

	constructor(
		private cartService: CartService, 
		public appService: AppService, 
		public translate: TranslateService,
		private route: ActivatedRoute){
			super(appService, translate);
		}

	ngOnInit(): void {
		this._status = this.route.snapshot.paramMap.get('status');
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
